import React from 'react';

export default function LocationSection({ lat, lon, onOpenMap, className }) {
    const hasLocation = typeof lat === 'number' && typeof lon === 'number';

    return (
        <section className={['shop-create-section', className].filter(Boolean).join(' ')}>
            <div className="shop-create-row">
                <div>
                    <div className="shop-create-label">Локация {hasLocation ? '✅' : <b style={{ color: 'red' }}>*</b>}</div>
                    <div className="shop-create-help">
                        Нажмите точку на карте
                    </div>
                </div>
                <button
                    className="shop-create-buttonSecondary"
                    type="button"
                    onClick={onOpenMap}
                >
                    Выбрать на карте {hasLocation ? '' : '📍'}
                </button>
            </div>
        </section>
    );
}

